const Highcharts = require('highcharts/highstock');


const date_time_grouping_label_formats = {
  millisecond: ['%d-%m-%Y'],
  second: ['%d-%m-%Y'],
  minute: ['%d-%m-%Y'],
  hour: ['%d-%m-%Y'],
  day: ['%d-%m-%Y'],
  week: ['%m-%Y'],
  month: ['%m-%Y'],
  year: ['%Y']
};

const date_time_label_formats = {
  millisecond: '%d-%m-%Y',
  second: '%d-%m-%Y',
  minute: '%d-%m-%Y',
  hour: '%d-%m-%Y',
  day: '%d-%m-%Y',
  week: '%m-%Y',
  month: '%m-%Y',
  year: '%Y'
};

Highcharts.setOptions({
  exporting: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  xAxis: {
    dateTimeLabelFormats: date_time_label_formats
  },
  series: {
    dataGrouping: {
      dateTimeLabelFormats: date_time_grouping_label_formats
    }
  },
  tooltip: {
    dateTimeLabelFormats: date_time_label_formats
  },
  title: {
    text: null
  }
});
